import { RootState } from "../store";

export const selectSignumState = (state: RootState) => state.signumState;
